import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ContratoService } from '../services/contrato.service';
import * as ContratoActions from './contrato.actions';

@Injectable()
export class ContratoEffects {
  private readonly actions$ = inject(Actions);
  private readonly contratoService = inject(ContratoService);
  private readonly store = inject(Store);

  // Load Contratos
  loadContratos$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContratoActions.loadContratos),
      switchMap(() =>
        this.contratoService.getContratos().pipe(
          map(contratos => ContratoActions.loadContratosSuccess({ contratos })),
          catchError(error => {
            return of(
              ContratoActions.loadContratosFailure({
                error: error.message || 'Error al cargar los contratos'
              })
            );
          })
        )
      )
    )
  );

  // Create Contrato
  createContrato$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContratoActions.createContrato),
      switchMap(action =>
        this.contratoService.createContrato(action.contrato).pipe(
          switchMap(result =>
            this.contratoService.getContratoById(result.id).pipe(
              map(createdContrato =>
                ContratoActions.createContratoSuccess({
                  contrato: createdContrato
                })
              )
            )
          ),
          catchError(error => {
            return of(
              ContratoActions.createContratoFailure({
                error: error.message || 'Error al crear el contrato'
              })
            );
          })
        )
      )
    )
  );

  // Update Contrato
  updateContrato$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContratoActions.updateContrato),
      switchMap(action =>
        this.contratoService.updateContrato(action.id, action.contrato).pipe(
          switchMap(() =>
            this.contratoService.getContratoById(action.id).pipe(
              map(updatedContrato =>
                ContratoActions.updateContratoSuccess({
                  contrato: updatedContrato
                })
              )
            )
          ),
          catchError(error => {
            return of(
              ContratoActions.updateContratoFailure({
                error: error.message || 'Error al actualizar el contrato'
              })
            );
          })
        )
      )
    )
  );
}
